import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';


export const ChangePasswordReducer = combineReducers({
                                                         records: recordsReducer,
                                                     });

